import request from '@/utils/request'
const apiPath = '/cust_service/custServiceSpeechcraft'
import { downloadBlob } from '@/utils/download'
const custServiceSpeechcraftApi = {
  /**
   * 新增【常用语】
   */
  create(data) {
    return request.post(apiPath + '/tee/saveBatch', data)
  },
  createMe(data) {
    return request.post(apiPath + '/tee/saveBatchForOWN', data)
  },
  /**
   * 修改【常用语】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  updateMe(data) {
    return request.put(apiPath + '/tee/updateForOWN', data)
  },
  /**
   * 分页查询【常用语】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee', { params: query })
  },
  fetchForList(query) {
    return request.get(apiPath + '/tee/listPageForMini', { params: query })
  },
  fetchForMeList(query) {
    return request.get(apiPath + '/tee/listPageForMiniOWN', { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【常用语】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【常用语】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  deleteByIdMe(id) {
    return request.delete(`${apiPath}/tee/deleteForOWN/${id}`)
  },
  setIsEnable(data) {
    return request.put(apiPath + '/tee/setIsEnable', data)
  },
}
export default custServiceSpeechcraftApi
